module.exports = __webpack_public_path__ + "static/media/Las-poesias-de-Rafael-Pombo-min.f5e8d8b2.png";